export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>香蕉视频 · 红桃视频 · 蜜桃视频</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-4">
              番茄视频 - 海量高清影视免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-semibold mb-6">
              高清不缓冲，追剧更畅快
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              番茄视频汇聚香蕉视频、红桃视频、蜜桃视频、91视频等全网高清影视资源，涵盖最新电影、热门电视剧、人气综艺全集免费在线观看。采用高速CDN分发技术，无论何时何地都能享受流畅不缓冲的极致高清画质播放体验，满足您多样化的追剧需求。每日更新最新片源，热门剧集同步上线，让您不错过任何精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">10万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">1080P</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">高清画质</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600 font-heading">极速</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">流畅不缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer text-sm border border-background-300/60"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20viewing%20experience%20with%20large%20display%20screen%20showing%20vibrant%20film%20content%2C%20cozy%20living%20room%20atmosphere%20with%20warm%20ambient%20lighting%2C%20modern%20minimal%20interior%2C%20golden%20hour%20tones%2C%20comfortable%20sofa%2C%20immersive%20entertainment%20setup%2C%20soft%20shadows%2C%20cinematic%20color%20grading%2C%20high%20quality%20photography&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="番茄视频高清观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-2xl"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-play-fill text-background-50 text-xl"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="h-1.5 bg-background-50/40 rounded-full overflow-hidden">
                    <div className="h-full w-3/5 bg-primary-500 rounded-full"></div>
                  </div>
                  <div className="flex items-center justify-between mt-1.5">
                    <span className="text-xs text-background-50/90">42:18 / 1:28:36</span>
                    <span className="text-xs text-background-50/90">1080P</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}